// extracted by mini-css-extract-plugin
export var statItem = "_fg-1";
export var statsRow = "_fg-0";